var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { SortMenu } from './SortMenu/SortMenu';
import { Table } from './Table/Table';
import { Direction, SortTypes } from '../../types';
import { useYearlyTableData } from '../../hooks/useYearlyTableData';
var Container = styled.section.withConfig({ displayName: "Container", componentId: "sc-1xl2hsv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ScSortMenu = styled(SortMenu).withConfig({ displayName: "ScSortMenu", componentId: "sc-18of2z7" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 280px;\n  margin-bottom: 8px;\n"], ["\n  width: 280px;\n  margin-bottom: 8px;\n"])));
var ScTable = styled(Table).withConfig({ displayName: "ScTable", componentId: "sc-19pc9vl" })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var sortItems = [
    {
        text: 'Sort by Placement Test Level',
        direction: Direction.Desc,
        sortType: SortTypes.PT,
    },
    {
        text: 'Sort by Placement Test Level',
        direction: Direction.Asc,
        sortType: SortTypes.PT,
    },
    {
        text: 'Sort by Current Grade Level',
        direction: Direction.Asc,
        sortType: SortTypes.Grade,
    },
    {
        text: 'Sort by Current Grade Level',
        direction: Direction.Desc,
        sortType: SortTypes.Grade,
    },
    {
        text: 'Sort by Time Spent',
        direction: Direction.Asc,
        sortType: SortTypes.Time,
    },
    {
        text: 'Sort by Time Spent',
        direction: Direction.Desc,
        sortType: SortTypes.Time,
    },
    {
        text: 'Sort by Student Name',
        direction: Direction.Asc,
        sortType: SortTypes.Student,
    },
    {
        text: 'Sort by Student Name',
        direction: Direction.Desc,
        sortType: SortTypes.Student,
    },
];
var StudentsTable = function (_a) {
    var isTeacherPremium = _a.isTeacherPremium, studentsData = _a.studentsData, startGrade = _a.startGrade, endGrade = _a.endGrade, currentGrade = _a.currentGrade, teacherName = _a.teacherName, role = _a.role, isClassPremium = _a.isClassPremium, onSortChange = _a.onSortChange, rest = __rest(_a, ["isTeacherPremium", "studentsData", "startGrade", "endGrade", "currentGrade", "teacherName", "role", "isClassPremium", "onSortChange"]);
    var _b = useState(SortTypes.PT), sortType = _b[0], setSortType = _b[1];
    var _c = useState(Direction.Desc), sortDirection = _c[0], setSortDirection = _c[1];
    var sortedData = useYearlyTableData(studentsData, sortType, sortDirection);
    useEffect(function () {
        if (onSortChange)
            onSortChange(sortType, sortDirection);
    }, [onSortChange, sortType, sortDirection]);
    return (_jsxs(Container, __assign({ "data-testid": 'students-table' }, rest, { children: [_jsx(ScSortMenu, { items: sortItems, onSort: function (type, direction) {
                    setSortType(type);
                    setSortDirection(direction);
                } }, void 0), sortedData && (_jsx(ScTable, { isTeacherPremium: isTeacherPremium, data: sortedData, startGrade: startGrade, endGrade: endGrade, currentGrade: currentGrade, teacherName: teacherName, isClassPremium: isClassPremium, role: role }, void 0))] }), void 0));
};
export { StudentsTable };
var templateObject_1, templateObject_2, templateObject_3;
